import { render, staticRenderFns } from "./ls-dialog.vue?vue&type=template&id=f0e800c2&scoped=true&"
import script from "./ls-dialog.vue?vue&type=script&lang=ts&"
export * from "./ls-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./ls-dialog.vue?vue&type=style&index=0&id=f0e800c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e800c2",
  null
  
)

export default component.exports